export const compareDate = (dateToCompare) => {
    return new Date(dateToCompare) > new Date() ? true : false
}